import React from 'react';
import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { NthUserHomeOnboardingTakeover } from '@confluence/experiment-home-onboarding-takeover-v2/entry-points/HomeOnboardingTakeoverV2.ts';
import type { OnboardingTakeoverType } from '@confluence/experiment-home-onboarding-takeover-v2/entry-points/useOnboardingTakeoverType.ts';
import { PersonalizedTemplatesV2Loadable } from '@confluence/experiment-personalized-templates-v2';
import { NthUserHomeOnboardingRevamp } from '@confluence/experiment-personalized-templates-v2/entry-points/NthUserHomeOnboardingRevamp.ts';

import { TemplateCollectionsLoader } from '../HomeViews/ForYou/CreateFromTemplate/index.ts';

const onboardingExperienceContainerStyles = css({
	gridColumn: '1 / span 1',
	// This will appear in either the 1st or 2nd row
	gridRow: '(1 + var(--home-show-rovo-awareness-banner)) / span 1',
	position: 'relative',

	marginBottom:
		'calc((32px - 32px * var(--homeIsSingleColumn)) + (12px * var(--homeIsSingleColumn)))',
});

const templatesContainerStyles = css({
	position: 'relative',
	gridColumn: '1 / span 1',
	// This will appear in either the 1st or 2nd row
	gridRow: '(1 + var(--home-show-rovo-awareness-banner)) / span 1',
	marginTop: '0px',

	marginBottom: token('space.300'),
});

type OnboardingTakeoverProps = {
	onboardingTakeoverType: OnboardingTakeoverType | null;
	isTemplatesCollectionEligible?: boolean;
};

export const OnboardingTakeover = ({
	onboardingTakeoverType,
	isTemplatesCollectionEligible,
}: OnboardingTakeoverProps) => {
	if (onboardingTakeoverType === 'nth-user') {
		return (
			<div css={onboardingExperienceContainerStyles}>
				<NthUserHomeOnboardingTakeover />
			</div>
		);
	}

	if (
		onboardingTakeoverType === 'personalized-templates-v2' ||
		onboardingTakeoverType === 'personalized-templates-v2-xflow'
	) {
		return (
			<div css={onboardingExperienceContainerStyles}>
				<PersonalizedTemplatesV2Loadable
					isXflow={onboardingTakeoverType === 'personalized-templates-v2-xflow'}
				/>
			</div>
		);
	}

	if (onboardingTakeoverType === 'use-cases-in-nth-user-onboarding') {
		return (
			<div css={onboardingExperienceContainerStyles}>
				<NthUserHomeOnboardingRevamp shouldShowUseCasesHomeWelcomeBanner />
			</div>
		);
	}

	if (onboardingTakeoverType === 'nth-user-home-onboarding-revamp') {
		return (
			<div css={onboardingExperienceContainerStyles}>
				<NthUserHomeOnboardingRevamp />
			</div>
		);
	}

	if (
		isTemplatesCollectionEligible &&
		onboardingTakeoverType !== 'personalized-templates-v2-xflow' &&
		onboardingTakeoverType !== 'personalized-templates-v2'
	) {
		return (
			<div css={templatesContainerStyles}>
				<TemplateCollectionsLoader />
			</div>
		);
	}

	return null;
};
